/** 한 번에 보여줄 페이지 번호 수 — 현재 페이지를 가운데 둔 번호 창의 폭. */
const WINDOW_SIZE = 5;

/** 현재 페이지를 가운데 두고 범위를 벗어나지 않는 번호 창을 만든다. */
export const pageWindowOf = (page: number, pageCount: number): readonly number[] => {
  const start = Math.max(
    1,
    Math.min(page - Math.floor(WINDOW_SIZE / 2), pageCount - WINDOW_SIZE + 1),
  );
  const end = Math.min(pageCount, start + WINDOW_SIZE - 1);

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
};
